const routesAdminEasy360 = [];

export default routesAdminEasy360;
